import React from 'react';

import { connect } from "react-redux";

import appStore from '../../../redux/store/appStore';
import { updateQuotationsFormField } from '../../../redux/actions/actions';

import { withRouter } from 'react-router-dom';

import {
    config as httpClientConfig,
    sendData as httpClientSendData
} from '../../../libs/http-client';
import { sendDataRequestData } from '../../../libs/http-client-dataManager';

import {
    getConfItem,
    getLabel
} from '../../../conf/conf';

import { pageComponentCssClass } from '../../../helpers/components-helper';

import Loading from '../../Loading';
import Header from '../../Header';
import Footer from '../../Footer';
import InputTextItem from './InputTextItem';
import ConfigurationSubmitResponse from './ConfigurationSubmitResponse';

import formHelper, { config as formConfig } from '../../../helpers/configurationSubmit-form-helper';
import { urlRewriteWithSearchStringFromState } from '../../../helpers/browser-navigation-helper';
import { lastStepUrlPathGet} from '../../../helpers/wizard-helper';

import './PageConfigurationSubmit.css';

const mapStateToProps = state => {
    return {
        gui: state.gui
    };
};

const FORM_TITLE = 'Inserisci i tuoi dati per inviare la configurazione';
const RESPONSE_SUCCESS_MESSAGE = `La simulazione è andata a buon fine.<br />Riceverai una email con il preventivo!`;
const RESPONSE_FAIL_MESSAGE = `Grazie per aver utilizzato il nostro configuratore.<br />Purtroppo non è stato possibile inviarti un'email con il preventivo.`;
const RESPONSE_HTTP_ERROR_MESSAGE = `Non è stato possibile soddisfare la richiesta.`;

class PageConfigurationSubmit extends React.Component {

    constructor(props) {

        // init props
        super(props);

        // init state
        this.state = {
            loading: false,
            sendDataResponse: {
                result: null,
                message: null
            }
        };

        // bind event listeners
        this.onSubmit = this.onSubmit.bind(this);
        this.onClickIndietro = this.onClickIndietro.bind(this);
        this.changeFormFieldListener = this.changeFormFieldListener.bind(this);
        this.sendDataResponseReset = this.sendDataResponseReset.bind(this);

    }

    /**                                                                 Web Api Communication
     * ======================================================================================
     */

     sendData() {

        this.setState((state, props) => ({
            loading: true
        }));

        const requestPayload = sendDataRequestData();

        httpClientSendData(requestPayload)
            /**
             * Success response
             * @param {Object} response
             *  .config (axios config)
             *  .data (actual data)
             *  .headers (http headers)
             *  .request (xmlhttp)
             */
            .then(function(response) {
                this.onSendDataResponse(response.data);
            }.bind(this))
            .catch(function(error) {
                console.error(error);
                this.sendDataResponseHttpError(error)
                /*
                * Catches responses with error status codes (300, 400, 500)
                * Error cases:
                *  status === 500 && data.result === 'ko'
                * All other cases are evaluated as success cases
                * @param {Object} error
                if (error.response) {
                    //console.log('error data = ', error.response.data);
                    //console.log('error status = ', error.response.status);
                    //console.log('error headers = ', error.response.headers);
                    switch(true) {
                        case (error.response.status === 500 && error.response.data.result === 'ko'):
                            //console.log('status 500 && result ko');
                            this.sendDataResponseFail(error.response);
                            break;
                        default:
                            //console.log('status NOT 500 && result ko');
                            this.sendDataResponseOk(error.response);
                    }
                } else {
                    console.error('No response received by the server');
                }
                */
            }.bind(this));

    }

    /**
     * Handles sendData() response with status code 200
     * The response.result data is evaluated immediately in the promise catch clause, because it must be combined
     * ...with http status code value
     */
    onSendDataResponse(response) {
        if (response.result && response.result === 'OK') {
            this.sendDataResponseOk(response);
        } else {
            this.sendDataResponseFail(response);
        }
    }

    sendDataResponseOk(response) {
        this.setState((state, props) => ({
            loading: false,
            sendDataResponse: {
                result: 'success',
                message: RESPONSE_SUCCESS_MESSAGE
            }
        }));
    }

    sendDataResponseFail(response) {
        this.setState((state, props) => ({
            loading: false,
            sendDataResponse: {
                result: 'fail',
                message: RESPONSE_FAIL_MESSAGE
            }
        }));
    }

    sendDataResponseHttpError(error) {
        this.setState((state, props) => ({
            loading: false,
            sendDataResponse: {
                result: 'fail',
                message: RESPONSE_HTTP_ERROR_MESSAGE
            }
        }));
    }

    sendDataResponseReset() {
        this.setState((state, props) => ({
            sendDataResponse: {
                result: null,
                message: null
            }
        }));
    }

    /**                                                                             Lifecycle
     * ======================================================================================
     */

    componentDidMount() {
        httpClientConfig({
            baseUrl: getConfItem('api.' + process.env.NODE_ENV + '.baseUrl')
        });
        formHelper.formStart(formConfig);
    }

    /**                                                                        Event Handlers
     * ======================================================================================
     */

    onSubmit(evt) {
        const validationResult = formHelper.formValidate(formConfig);
        if (validationResult.valid) {
            this.sendData();
        } else {
            formHelper.domGuiFieldsInvalid(validationResult.invalidFields, formConfig);
        }
    }

    onClickIndietro(evt) {
        this.navigateBack();
    }

    /**
     * Event listener for any input element change event
     * @param {*} evt 
     */
     changeFormFieldListener(evt) {

        // get field element and config
        const $field = evt.target;
        const value = $field.value;
        
        const fieldId = formHelper.fieldResolveId($field);
        const fieldConfig = formHelper.fieldGetConfig(fieldId, formConfig);

        // validate field
        const validated = formHelper.fieldValidate($field, fieldConfig);

        // update field data in store and field gui valid/invalid feedback accordingly
        if (validated) {
            const payload = {};
            payload[fieldId] = value;
            appStore.dispatch(updateQuotationsFormField(payload));
            formHelper.domGuiFieldValid($field);
        } else {
            const payload = {};
            payload[fieldId] = null;
            appStore.dispatch(updateQuotationsFormField(payload));
            formHelper.domGuiFieldInvalid($field);
        }

        // update form valid flag in store
        const formValid = formHelper.formValidate(formConfig);
        appStore.dispatch(updateQuotationsFormField({
            valid: formValid.valid
        }));
        
        // update submit button state
        this.submitBtnManageState();

    }

    /**
     * Manages the submit btn state
     * Simple wrapper to formHelper.submitBtnManageState(formConfig) function
     */
    submitBtnManageState() {
        formHelper.submitBtnManageState(formConfig);
    }

    /**                                                                            Navigation
     * ======================================================================================
     */

    /**
     * Navigates back to Wizard last Step
     */
     navigateBack() {
        this.props.history.push(urlRewriteWithSearchStringFromState(lastStepUrlPathGet()));
    }

    /**                                                                                  Misc
     * ======================================================================================
     */

    fieldGetValue(fieldId) {
        const fieldConfig = formHelper.fieldGetConfig(fieldId, formConfig);
        return (typeof(fieldConfig.getValue) === 'function') ?
            fieldConfig.getValue() :
            '';
    }

    fieldGetStoreValue(fieldId) {
        const fieldConfig = formHelper.fieldGetConfig(fieldId, formConfig);
        return (typeof(fieldConfig.getStoreValue) === 'function') ?
            fieldConfig.getStoreValue() :
            '';
    }

    /**
     * Returns the page css class name
     * @return {String}
     *  Sample
     *      'slc-page slc-page-quotations responsive-desktop
     */
    pageClassName() {
        return pageComponentCssClass('configurationSubmit', this.props.gui.responsive);
    }

    render() {

        const loading = (this.state.loading) ? <Loading label={getLabel('gui.loading')} layout="absolute" /> : null ;

        return (
            <div className={ this.pageClassName() }>
                { loading }
                { this.state.sendDataResponse.result && (
                    <ConfigurationSubmitResponse
                        sendDataResponse={ this.state.sendDataResponse }
                        sendDataResponseReset={ this.sendDataResponseReset } />
                )}                
                <div className="row slc-page-header">
                    <div className="col s12">
                        <Header />
                    </div>
                </div>
                <div className="row slc-page-body slc-container">
                    <div className='slc-configurationSubmit-form'>
                        <div className="slc-configurationSubmit-form__title slc-font-title">{ FORM_TITLE }</div>
                        <div className="slc-configurationSubmit-form__inputs">

                            <InputTextItem
                                id="nome"
                                placeholder="Nome"
                                value={ this.fieldGetStoreValue('nome') }
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="cognome"
                                placeholder="Cognome"
                                value={ this.fieldGetStoreValue('cognome') }
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="email"
                                placeholder="Email"
                                value={ this.fieldGetStoreValue('email') }
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="telefono"
                                placeholder="Cellulare"
                                value={ this.fieldGetStoreValue('telefono') }
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="ragioneSociale"
                                value={ this.fieldGetStoreValue('ragioneSociale') }
                                placeholder="Ragione sociale"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="indirizzo"
                                value={ this.fieldGetStoreValue('indirizzo') }
                                placeholder="Indirizzo"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="numerocivico"
                                value={ this.fieldGetStoreValue('numerocivico') }
                                placeholder="Numero civico"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="comune"
                                value={ this.fieldGetStoreValue('comune') }
                                placeholder="Comune"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="cap"
                                value={ this.fieldGetStoreValue('cap') }
                                placeholder="CAP"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <InputTextItem
                                id="provincia"
                                value={ this.fieldGetStoreValue('provincia') }
                                placeholder="Provincia (Esempio: MI)"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                            <div className="slc-form-input-select-widget" id="tipoImmobile">
                                <div className="slc-form-input-select-widget__input-container">
                                    <select 
                                        className="slc-form-input-select-widget__input slc-form-input-text-widget__input-tipoImmobile"
                                        onChange={this.changeFormFieldListener}>
                                        <option value="">Tipo di appartamento</option>
                                        <option value="casaSingola">Casa singola</option>
                                        <option value="casaSchiera">Casa a schiera</option>
                                        <option value="bifamiliare">Bifamiliare</option>
                                        <option value="condominio">Condominio</option>
                                        <option value="capannone">Capannone</option>
                                    </select>
                                </div>
                            </div>

                            <InputTextItem
                                id="emailCommerciale"
                                value={ this.fieldGetStoreValue('emailCommerciale') }
                                placeholder="Email agente"
                                changeFormFieldListener= { this.changeFormFieldListener } />

                        </div>
                        <div>I suoi dati saranno trattati ai sensi di quanto previsto dall'<a href={`${ getConfItem('gui.docs.basePath') }/Policy-Privacy.pdf`} target="_blank" rel="noopener noreferrer">informativa sulla privacy</a>.</div>
                        <div className="slc-configurationSubmit-form__buttons">
                            <button
                                id="slc-button-back"
                                className="slc-btn-gradient-text slc-quotations-nav-button btn btn-next btn-primary btn-lg"
                                onClick={ this.onClickIndietro }>
                                Indietro
                            </button>
                            <button
                                id="slc-button-submit"
                                className="slc-button-gradient slc-button btn btn-primary btn-lg"
                                onClick={ this.onSubmit }>
                                    Invia la configurazione
                            </button>
                        </div>
                    </div>
                </div>
                <div className="slc-page-footer">
                    <Footer />
                </div>

            </div>
        );

    }

}

export default withRouter(connect(mapStateToProps)(PageConfigurationSubmit));